export default __webpack_public_path__ + "cb84a2080965ae249539b606da4434df.png";